import Swiper from 'swiper/bundle';

const container = document.querySelector(".swiper");
let swiper = null;
if (container) {
    swiper = new Swiper(container, {
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

const radio_size_all = document.querySelectorAll(".webshop__product-details-size-radio");
if (radio_size_all) {
    const label_elements = document.querySelectorAll('.webshop__product-details-size-label');
    if (label_elements.length) {
        for (let i = 0; i < label_elements.length; i++) {
            label_elements[i].addEventListener('click', () => {
                let swiper_id = null;
                let current_id = label_elements[i].id;
                let current_variant_image = document.getElementById('webshop__product-details-size-image-'+current_id);
                if (swiper && swiper.imagesToLoad && swiper.imagesToLoad.length > 0 && current_variant_image.value != "") {
                    for (let j = 0; j < swiper.imagesToLoad.length; j++) {
                        if(swiper.imagesToLoad[j].id == current_variant_image.value) {
                            swiper_id = j;
                        }
                    }
                    if (swiper_id!=null) {
                        swiper.slideTo(swiper_id);
                    }
                }
            });

        }
    }
}